<template>
    <CCard>      
        <CCardBody>
            <CRow>        
                <div class="col-lg-12 control-section">
                    <div class="content-wrapper">
                      <div id="app">
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='grid' locale='zh-TW' :dataSource='this.datas' :childGrid='this.childdatas' height='500' :allowExcelExport='true'
                                :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true' :toolbar='toolbar' 
                                :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' 
                                :load='load' :toolbarClick="toolbarClick" :rowSelected='rowSelected' :recordDoubleClick="pubDoubleClick"  >
                                <e-columns>
                                    <e-column field='date' headerText='生產日期' aria-required="true" :isPrimaryKey='true' width='130'></e-column>              
                                    <e-column field='name' headerText='生產品名' width='250'></e-column> 
                                    <e-column field='abnormal' headerText='異常狀況' width='130' ></e-column> 
                                    <e-column field='dispose' headerText='異常處置' width='130' ></e-column> 
                                    <e-column field='analyze' headerText='原因分析' width='130' ></e-column> 
                                    <e-column field='manager_sign' headerText='簽核人' width='80' :template="signTemplate" ></e-column>
                                    <e-column field='form_user' headerText='填表人' width='80' :template="userTemplate"></e-column>
                                    <e-column field='report' headerText='生產日報表' width='80' :template="urlTemplate" :allowFiltering='false'></e-column>
                                </e-columns>
                            </ejs-grid>        
                        </ejs-tooltip>
                      </div>                  
                    </div>                       
                </div>  
            </CRow>
        </CCardBody>
        <div class="control-section">
            <ejs-dialog ref="modalDialog" showCloseIcon='true' isModal='true' :visible='visible'
                width='500' :animationSettings='animationSettings' closeOnEscape='true' >
                    <div class="default-timeline-section">
                        <Timeline
                        :timeline-items="timelineItems"
                        :message-when-no-items="messageWhenNoItems"
                        :unique-year="false"
                        order="acs"/>
                </div>
            </ejs-dialog>                        
        </div>
        <div class="control-section">
            <ejs-dialog ref="dialogSign" showCloseIcon='true' isModal='true' :visible='false' header='簽名'  width='600px' closeOnEscape='true' >
                <SignTemplate ref="mySignTemplate" v-on:onSignClose="onSignTemplateItem"  style="justify-content: center; "></SignTemplate>
            </ejs-dialog>
        </div>   
    </CCard>
  </template>
  
  <style lang="scss" src="../../scss/grid.scss"></style>
  <script>
  
    import Vue from "vue";
    import { L10n, enableRipple  } from '@syncfusion/ej2-base';
    import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
    import { TextBoxPlugin, NumericTextBoxPlugin  } from '@syncfusion/ej2-vue-inputs';
    import { ButtonPlugin, CheckBoxPlugin, RadioButtonPlugin  } from '@syncfusion/ej2-vue-buttons';    
    import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import { GridComponent, ColumnsDirective, ColumnDirective, GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
    import Timeline from 'timeline-vuejs'
    import SignTemplate from "./compone/Sign.vue";
    import zhtwLocalization  from '../language/language.json';

L10n.load(zhtwLocalization);
  
    enableRipple(true);
    Vue.use(DialogPlugin);
    Vue.use(GridPlugin);    
    Vue.use(ButtonPlugin);
    Vue.use(CheckBoxPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(NumericTextBoxPlugin );
    Vue.use(RadioButtonPlugin);
    Vue.use(TooltipPlugin);
    Vue.prototype.$eventHub = new Vue(); 
  
    export default Vue.extend({     
        components: {
          Timeline,
          'ejs-grid': GridComponent,
          'e-columns': ColumnsDirective,
          'e-column': ColumnDirective,
          SignTemplate
        },
        data: function() {
          return {
              datas : [
                { 'date' : '2025-01-01', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '', 'form_user' : '', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'}, 
                { 'date' : '2025-01-02', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '有異物' , 'dispose' : '清除', 'analyze':'無', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'}, 
                { 'date' : '2025-01-03', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'','manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'}, 
                { 'date' : '2025-01-04', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'}, 
                { 'date' : '2025-01-05', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'}, 
                { 'date' : '2025-01-06', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'},  
                { 'date' : '2025-01-07', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'},  
                { 'date' : '2025-01-08', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'}, 
                { 'date' : '2025-01-09', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'},  
                { 'date' : '2025-01-10', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'}, 
                { 'date' : '2025-01-11', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'}, 
                { 'date' : '2025-01-12', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'}, 
                { 'date' : '2025-01-13', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'}, 
                { 'date' : '2025-01-14', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'}, 
                { 'date' : '2025-01-15', 'name' : '蘋果、梅子、蜂蜜蘋果、桑葚', 'abnormal' : '' , 'dispose' : '', 'analyze':'', 'manager_sign': '小小明', 'form_user' : '小小明', 'report' : 'https://www.gfnnet.com/pccv.workstation.api/Report/Production?no=1&token=2'}, 
              ],
              pageSettings: {pageSize: 10, pageSizes: [10,50,100,200], pageCount: 10 },     
              toolbar: [{ text: '匯出Excel', tooltipText: '匯出Excel', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' },'Search'],     
              filterSettings: { type: 'Excel' },
              selectionSettings: { persistSelection: true },
              animationSettings: { effect: 'Fade' },
              visible : false,
  
              childdatas: {
                  dataSource: [ 
                      { 'date' : '2025-01-01', 'name' : '蘋果', 'target' : '1000L', 'real' : '980L', 'efficiency' : '98%' },
                      { 'date' : '2025-01-01', 'name' : '梅子', 'target' : '1000L', 'real' : '950L', 'efficiency' : '95%' },
                      { 'date' : '2025-01-01', 'name' : '蜂蜜蘋果', 'target' : '1000L', 'real' : '920L', 'efficiency' : '92%' },
                      { 'date' : '2025-01-01', 'name' : '桑葚', 'target' : '1000L', 'real' : '990L', 'efficiency' : '99%' },
                      { 'date' : '2025-01-02', 'name' : '蘋果', 'target' : '1000L', 'real' : '980L', 'efficiency' : '98%' },
                      { 'date' : '2025-01-02', 'name' : '梅子', 'target' : '1000L', 'real' : '950L', 'efficiency' : '95%' },
                      { 'date' : '2025-01-02', 'name' : '蜂蜜蘋果', 'target' : '1000L', 'real' : '920L', 'efficiency' : '92%' },
                      { 'date' : '2025-01-02', 'name' : '桑葚', 'target' : '1000L', 'real' : '990L', 'efficiency' : '99%' }
                  ],
                  queryString: "date",   
                  columns: [             
                      { field: "name", headerText: "生產品名", width: 120 },
                      { field: "target", headerText: "目標產量", width: 120 },
                      { field: "real", headerText: "實際產量", width: 120 },         
                      { field: "efficiency", headerText: "產出效率", width: 120 },
                  ],
              },
  
  
              messageWhenNoItems: 'There are not items',
              timelineItems: [
                {
                  from: new Date(2024, 1, 1, 8, 39, 21),
                  title: '蘋果生產完成',color: '#e74c3c', showDayAndMonth: false,
                  description:'完成時間 12:09:20' 
                },
                {
                  from: new Date(2025, 1, 1, 8, 45, 21),
                  title: '梅子生產完成',color: '#e74c3c', showDayAndMonth: false,
                  description:'完成時間 12:09:20' 
                },
                {
                  from: new Date(2025, 1, 1, 9, 39, 21),
                  title: '蜂蜜蘋果生產完成',color: '#e74c3c', showDayAndMonth: false,
                  description:'完成時間 12:09:20' 
                },
                {
                  from: new Date(2025, 1, 1, 8, 39, 21),
                  title: '桑葚生產完成',color: '#e74c3c', showDayAndMonth: false,
                  description:'完成時間 12:09:20' 
                }
              ],
              signTemplate: function () {
                  return {
                      template: Vue.component('signTemplate', {
                          template: `<div id="coordinates">
                                  <span id="locationtext">{{data.manager_sign}}<a @click="doSomething" href="#"><img src="img/icon/pen.png" class="e-image" width="20px"/></a></span>   
                                  </div>`,
                          data: function () { return { data: {} }; },
                          computed: { }, 
                          methods: {
                            doSomething(e) {
                                this.$eventHub.$emit('sign',e);                               
                            }                          
                          }
                      })
                  }
              },
              userTemplate: function () {
                  return {
                      template: Vue.component('userTemplate', {
                          template: `<div id="coordinates">
                                  <span id="locationtext">{{data.form_user}}<a @click="doSomething" href="#"><img src="img/icon/pen.png" class="e-image" width="20px"/></a></span>   
                                  </div>`,
                          data: function () { return { data: {} }; },
                          computed: { },
                          methods: {
                            doSomething(e) {
                                this.$eventHub.$emit('sign',e);                               
                            }                          
                        }
                      })
                  }
              },
              urlTemplate: function () {
                  return {
                      template: Vue.component('urlTemplate', {
                          template: `<div id="coordinates">
                                  <span id="locationtext"><a target="_blank" :href="data.report"><img src="img/icon/report.png" class="e-image" width="30px" :alt="data.report"/></a></span>        
                                  </div>`,
                          data: function () { return { data: {} }; },
                          computed: { }
                      })
                  }
              }         
        };
    },         
    mounted: function(){
        
    },
    methods: {           
        beforeRender: function (args) {
            if (args.target.closest("td")) {
                this.$refs.tooltip.content = args.target.innerText;                
            }
        },   
        pubDoubleClick: function () {  
            this.$refs.modalDialog.show();
        },
        editOkClick: function () {           
            this.upData();         
        },
        valueChange: function () {  
            this.isDataChanged = true;
            this.stTime = null;
        },
        load: function() {   
  
        },       
        addAction: function() {
  
        },      
        toolbarClick: function(args) {
          if (args.item.id == "Export") {
              this.$refs.grid.excelExport();
          }
        },   
  
        actionComplete: function() {                             
        },
        rowSelected: function() {          
        },    
        showError: function(error) {
            if (error.response.status == 400) {
                for(var key in error.response.data.errors){                 
                    this.$toast.open({message: error.response.data.errors[key][0] , type: "warning", duration: 5000, dismissible: true}) 
                }
                return;
            }    
            if (error.response.status == 401) {  
                localStorage.removeItem('token'); this.$router.push('/login'); 
                return; 
            }                
            this.$toast.open({message: '系統發生錯誤' + error.response.status, type: "error", duration: 5000, dismissible: true}) 
        }
    },
    created() {        
        this.$eventHub.$on('sign', ()=>{ 
            this.$refs.dialogSign.show();
      }); 
    },
    beforeDestroy() {
        this.$eventHub.$off('sign');
    },
    computed: {
    },
  
    provide: {
        grid: [PdfExport, ExcelExport, Sort , DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]      
    }
    });
  </script>
  
  <style scoped>
      @import "../../scss/grid.scss"
  </style>